import React, { useImperativeHandle, useRef, useState } from "react";
import { CheckoutCreditOrderDialog, TodoDialog } from "@icoach/memberDetail/dialog";
import SmartFitnessBandOverdueDialog from "@icoach/smartFitnessBand/dialog/SmartFitnessBandOverdueDialog";
import { isEqual, isFunction } from "@util/utils";
import SmartFitnessBandEditCreditCardDialog from "@icoach/smartFitnessBand/dialog/SmartFitnessBandEditCreditCardDialog";

const TODO_DIALOG = "todoDialog";
const CHECKOUT_CREDIT_ORDER_DIALOG = "checkoutCreditOrderDialog";
const SMART_FITNESS_BAND_OVERDUE_DIALOG = "smartFitnessBandOverdueDialog";
const SMART_FITNESS_BAND_EDIT_CREDIT_DIALOG = "smartFitnessBandEditCreditCardDialog";

const MemberSummaryTipDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState(null);
	const [sourceData, setSourceData] = useState(null);

	const refreshRef = useRef(null);

	const handleDialogClose = () => {
		refreshRef.current = null;
		setOpenDialog(null);
		setSourceData(null);
	};

	const doRefresh = (...arg) => {
		const refreshFn = refreshRef.current;
		if (isFunction(refreshFn)) {
			setTimeout(() => refreshFn(...arg), 5);
		}
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				openCheckoutCreditOrderDialog: (targetData, _refreshFn) => {
					if (isFunction(_refreshFn)) refreshRef.current = _refreshFn;
					setSourceData(targetData);
					setOpenDialog(CHECKOUT_CREDIT_ORDER_DIALOG);
				},
				openSmartFitnessBandOverdueDialog: (targetData, _refreshFn) => {
					if (isFunction(_refreshFn)) refreshRef.current = _refreshFn;
					setSourceData(targetData);
					setOpenDialog(SMART_FITNESS_BAND_OVERDUE_DIALOG);
				},
				openTodoDialog: (targetData, _refreshFn) => {
					if (isFunction(_refreshFn)) refreshRef.current = _refreshFn;
					setSourceData(targetData);
					setOpenDialog(TODO_DIALOG);
				},
				openSmartFitnessBandEditCreditCardDialog: (targetData, _refreshFn) => {
					if (isFunction(_refreshFn)) refreshRef.current = _refreshFn;
					setSourceData(targetData);
					setOpenDialog(SMART_FITNESS_BAND_EDIT_CREDIT_DIALOG);
				},
				closeDialog: () => handleDialogClose(),
			};
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<React.Fragment>
			<CheckoutCreditOrderDialog title="欠費明細" open={isEqual(openDialog, CHECKOUT_CREDIT_ORDER_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<SmartFitnessBandOverdueDialog open={isEqual(openDialog, SMART_FITNESS_BAND_OVERDUE_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<TodoDialog open={isEqual(openDialog, TODO_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<SmartFitnessBandEditCreditCardDialog open={isEqual(openDialog, SMART_FITNESS_BAND_EDIT_CREDIT_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
		</React.Fragment>
	);
});

export default MemberSummaryTipDialogBox;
